"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.profileSchema = void 0;
var constants_1 = require("@hobt/constants");
var constants_2 = require("../../constants");
var claim_status_schema_1 = require("./claim-status-schema");
exports.profileSchema = {
    type: 'object',
    required: [
        'claimStatus',
        'submitterRecordCreatedTimestamp',
        'submitterUserID',
        'submitterUserTypeCode',
    ],
    properties: {
        adjudicatorUserID: {
            type: ['string', 'null'],
            format: 'uuid',
            errorMessage: 'Should follow UUID format 00000000-0000-0000-0000-000000000000',
        },
        cancellationReasonCode: {
            type: ['string', 'null'],
            enum: __spreadArrays(Object.values(constants_2.CancellationReason), [null]),
            errorMessage: 'Should equate to a valid CancellationReason Enum value',
        },
        cancellationReasonNote: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 100,
            errorMessage: 'Should be a string with a maximum of 100 characters or null',
        },
        chequeCancelledDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'Should follow date format YYYY-MM-DD or null',
        },
        claimAssignmentTimestamp: {
            type: ['string', 'null'],
            pattern: constants_1.dateTimePattern,
            errorMessage: 'Should have date-time format YYYY-MM-DD 00:00:00.000000',
        },
        claimCancelledDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'Should follow date format YYYY-MM-DD or null',
        },
        claimPaidDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'Should follow date format YYYY-MM-DD or null',
        },
        claimStatus: claim_status_schema_1.claimStatusSchema,
        declineReasonCode: {
            type: ['integer', 'null'],
            // TODO: find values for declineReasonCode
            errorMessage: 'Should equate to a valid DeclineReason Enum value',
        },
        declineReasonNote: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 100,
            errorMessage: 'Should be a string with a maximum of 100 characters or null',
        },
        dueDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'Should follow date format YYYY-MM-DD or null',
        },
        submitterRecordCreatedTimestamp: {
            type: 'string',
            pattern: constants_1.dateTimePattern,
            errorMessage: 'Should have date-time format YYYY-MM-DD 00:00:00.000000',
        },
        submitterUserID: {
            type: 'string',
            format: 'uuid',
            errorMessage: 'Should follow UUID format 00000000-0000-0000-0000-000000000000',
        },
        submitterUserTypeCode: {
            type: 'number',
            enum: Object.values(constants_1.UserType),
            errorMessage: 'Should equate to a valid SubmitterUserType Enum value',
        },
    },
};
